export const REST_API_URL =
  "https://0bl1kulea6.execute-api.eu-central-1.amazonaws.com/production";

export const SESSIONS_TABLE_NAME = "shmenti-sessions";
export const QUESTIONS_TABLE_NAME = "shmenti-questions";

export const headers = {
  "Content-Type": "application/json",
};
